import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/shared/reducers/user-management';
import { IInterview } from 'app/shared/model/interview.model';
import { getEntities as getInterviews } from 'app/entities/interview/interview.reducer';
import { IInterviewParticipant } from 'app/shared/model/interview-participant.model';
import { InterviewProcess } from 'app/shared/model/enumerations/interview-process.model';
import { getEntity, updateEntity, createEntity, reset } from './interview-participant.reducer';

export const InterviewParticipantUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const users = useAppSelector(state => state.userManagement.users);
  const interviews = useAppSelector(state => state.interview.entities);
  const interviewParticipantEntity = useAppSelector(state => state.interviewParticipant.entity);
  const loading = useAppSelector(state => state.interviewParticipant.loading);
  const updating = useAppSelector(state => state.interviewParticipant.updating);
  const updateSuccess = useAppSelector(state => state.interviewParticipant.updateSuccess);
  const interviewProcessValues = Object.keys(InterviewProcess);

  const handleClose = () => {
    navigate('/interview-participant' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUsers({}));
    dispatch(getInterviews({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...interviewParticipantEntity,
      ...values,
      user: users.find(it => it.id.toString() === values.user.toString()),
      interview: interviews.find(it => it.id.toString() === values.interview.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          processStatus: 'Accepted',
          ...interviewParticipantEntity,
          user: interviewParticipantEntity?.user?.id,
          interview: interviewParticipantEntity?.interview?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.interviewParticipant.home.createOrEditLabel" data-cy="InterviewParticipantCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.interviewParticipant.home.createOrEditLabel">
              Create or edit a InterviewParticipant
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="interview-participant-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.interviewParticipant.processStatus')}
                id="interview-participant-processStatus"
                name="processStatus"
                data-cy="processStatus"
                type="select"
              >
                {interviewProcessValues.map(interviewProcess => (
                  <option value={interviewProcess} key={interviewProcess}>
                    {translate('fivePlusApp.InterviewProcess.' + interviewProcess)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('fivePlusApp.interviewParticipant.dailyCoGuestLink')}
                id="interview-participant-dailyCoGuestLink"
                name="dailyCoGuestLink"
                data-cy="dailyCoGuestLink"
                type="text"
              />
              <ValidatedField
                id="interview-participant-user"
                name="user"
                data-cy="user"
                label={translate('fivePlusApp.interviewParticipant.user')}
                type="select"
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="interview-participant-interview"
                name="interview"
                data-cy="interview"
                label={translate('fivePlusApp.interviewParticipant.interview')}
                type="select"
              >
                <option value="" key="0" />
                {interviews
                  ? interviews.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/interview-participant" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default InterviewParticipantUpdate;
